import { render } from "./BookingEvent.vue?vue&type=template&id=217f2087&scoped=true"
import script from "./BookingEvent.vue?vue&type=script&lang=js"
export * from "./BookingEvent.vue?vue&type=script&lang=js"

import "./BookingEvent.vue?vue&type=style&index=0&id=217f2087&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217f2087"]])

export default __exports__